<template>
  <section>
    <div class="section_title">
      <img src="@/assets/img/cart_sub.jpg" />
      <h1 class="">ご注文</h1>
    </div>
    <h2 class="mb-0 mt-2 text-left">2.お届け先の選択</h2>
    <div class="form-navi my-5">
      <ul class="d-flex flex-wrap">
        <li class="px-3">1.カートを確認</li>
        <li class="here px-3">2.お届け先の選択</li>
        <li class="px-3">3.お支払い方法の選択</li>
        <li class="px-3">4.最終確認</li>
      </ul>
    </div>
    <section>
      <!-- 20160902 銀行振込対応で変更 -->
      <div class="detail-cart border box-p-20 mb-5">
        <AddressItem
          v-for="i in addresses"
          :key="i.sequentialNo"
          :type="i.type"
          :typeName="i.typeName"
          :sequentialNo="i.sequentialNo"
          :destName="i.destName"
          :zipCode="i.zipCode"
          :address1="i.address1"
          :address2="i.address2"
          :tel="i.tel"
          :shortestDate="i.shortestDate"
          :deliveryAddressNo="deliveryAddressNo"
          @selectAddress="deliveryAddressNo = $event"
          @updateAddress="getAddress"
        />
        <div class="box-p-20 text-center">
          <router-link to="/cart/delivery/addaddress" class="btn d-inline-block"
            >別送先住所を追加する</router-link
          >
        </div>
      </div>
    </section>
    <section id="DATE">
      <div class="detail-cart border box-p-20">
        <h2 class="mb-3 text-left">お届け指定日</h2>
        <p>
          最短でお届け出来る日時は、配送先によって変わります。
          <br />お届け指定日は、以下の範囲からお選びください。
          <br />
          <br />
          ご指定の配送先では<span>{{ wantRange }}</span
          >のお届け日がご指定頂けます。
          <br />
        </p>
        <div class="date-select mt-3">
          <form>
            <select v-model="year" class="k4 w-auto px-3 mb-2">
              <option
                v-for="(y, index) in years"
                :key="y.year"
                :value="y.year"
                :selected="index === 0"
              >
                {{ y.year }}
              </option>
            </select>
            <span class="mr-3">年</span>
            <select v-model="month" class="w-auto px-3 mb-2">
              <option
                v-for="(m, index) in months"
                :key="m.month"
                :value="m.month"
                :selected="index === 0"
              >
                {{ m.month }}
              </option>
            </select>
            <span class="mr-3">月</span>
            <select v-model="day" class="w-auto px-3 mb-2">
              <option
                v-for="(d, index) in days"
                :key="d.day"
                :value="d.day"
                :selected="index === 0"
              >
                {{ d.day }}
              </option>
            </select>
            <span class="mr-3">日</span>
            <select v-model="timezone" class="w-auto px-3 mb-2">
              <option
                v-for="(t, index) in timezones"
                :key="t.TimeCode"
                :value="t.TimeCode"
                :selected="index === 0"
              >
                {{ t.TimeZone }}
              </option>
            </select>
          </form>
          <p style="font-weight: bold">
            ※ご指定のお届け日の場合、<strong>{{ accountMonth }}</strong
            >月度の実績として計上されます。
          </p>
        </div>
      </div>
    </section>
    <div class="d-flex justify-content-around text-center column_sp">
      <div>
        <router-link to="/cart" class="btn d-inline-block mt-5"
          >カートを確認へ戻る</router-link
        >
      </div>
      <div>
        <button @click="next" class="btn d-inline-block my-5">
          お支払方法の選択へ進む
        </button>
      </div>
    </div>
  </section>
</template>

<style>
  .detail-cart label.name{
    font-size: 1.2em;
  }
</style>

<script>
import Request from "@/modules/Request";

import AddressItem from "./components/AddressItem";

let request = new Request();

export default {
  components: {
    AddressItem,
  },
  data() {
    return {
      addresses: [], // 住所リスト
      deliveryDays: [], // ドロップダウンの内容
      deliveryAddressNo: "", // 選択中の住所
      wantRange: "", // xx月xx日からxx月xx日 の部分

      // dd lists
      years: [],
      months: [],
      days: [],
      timezones: [],

      leadTime:"",
      timeSet:"",

      // dd values
      year: "",
      month: "",
      day: "",
      timezone: "",
      delivCompany: "",
      accountMonth: "",

      // 日付変更用のタイムゾーンデータ退避
      timeZoneData: [],
    };
  },
  mounted() {
    this.getAddress();
    window.scroll(0, 0);
  },
  watch: {
    year: function (val) {
      this.changeYear(val);
    },
    month: function (val) {
      this.changeMonth(val);
    },
    day: function (val) {
      this.changeDay(val);
    },
    deliveryAddressNo: function(val) {
      this.changeDeliveryAddress(val);
      console.log(this.deliveryAddressNo);
    }
  },
  methods: {
    getAddress() {
      let postParams = [];
      let requestParams = request.createParams(
        "webMdlShippingAddress",
        "getAddress",
        postParams
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          this.addresses = data.addresses;
          this.deliveryDays = data.deliveryDays;
          this.deliveryAddressNo = data.deliveryAddressNo;
          this.wantRange = data.wantRange;

          // ロード時は順次番号をデフォルト選択する
          this.changeDeliveryAddress(this.deliveryAddressNo);
        });
    },
    changeYear(year) {
      if (!year) {
        // 年が無効なら先頭をデフォルト選択する
        year = this.years[0].year;
      }
      this.year = year;

      // 該当年のオブジェクトを取得し、月のリストを生成する
      this.months = [];
      const targetYear = this.years.find((el) => el.year == year);
      for (const monthItem of targetYear.months) {
        this.months.push(monthItem);
      }

      // 月のリストを再生成しているため、月は先頭を選択
      this.month = this.months[0].month;
    },
    changeMonth(month) {
      if (!month) {
        month = this.months[0].month;
      }
      this.month = month;

      this.days = [];
      //  該当月のオブジェクトを取得し、日のリストを生成する
      const targetMonth = this.months.find((el) => el.month == month);
      for (const dayItem of targetMonth.days) {
        this.days.push(dayItem);
      }

      // 日のリストを再生成しているため、日は先頭を選択
      this.day = this.days[0].day;
    },
    changeDay(day) {
      if (!day) {
        day = this.days[0].day;
      }
      this.day = day;

      // 選択された日から計上月を取得する
      const target = this.days.find((el) => this.day == el.day);
      this.accountMonth = target.acMonth;

      // 時間帯のリストを作成する
      this.timezones = [];
      for (const [index, tz] of this.timeZoneData.entries()) {
        if (this.years[0].year == this.year && this.months[0].month == this.month && this.days[0].day == this.day && index > 0) {
          if (tz.TimeDiv1 < tz.TimeDiv2) {
            continue;
          }
        }
        if (this.years[0].year == this.year && this.months[0].month == this.month && this.days[0].day == this.day) {
          console.log('this.TimeSet:'+this.TimeSet)
          if(this.timeSet == '0'){
           if(tz.TimeCode != 'A'){
            continue;
           } 
          }

          if(this.timeSet == '2'){
            switch(tz.TimeCode){
              case 'B':
                continue;
            }
          }

          if(this.timeSet == '3' || this.timeSet == '4'){
            switch(tz.TimeCode){
              case 'B':
                continue;
              case 'C':
                continue;
              case 'D':
                continue;
            }
          }
          
        }
        this.timezones.push(tz);
      }
    },
    // 住所を選択した時の挙動
    changeDeliveryAddress(sequentialNo) {
      // 選択する順次番号を用いて選択肢を構築する
      const data = this.deliveryDays[sequentialNo];
      this.timeZoneData = data.timeZones;
      // リストをクリアする
      this.years = [];
      this.timezones = [];

      // 年のリストを構築する
      // yearItem下には月、日リストも入っています
      for (const yearItem of data.ymdList) {
        this.years.push(yearItem);
      }

      // サーバへ住所番号を送信する（次のページで使用する）
      let postParams = [sequentialNo];
      let requestParams = request.createParams(
        "webMdlShippingAddress",
        "putAddressNo",
        postParams
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          let year = data.WantYear;
          let month = data.WantMonth;
          let day = data.WantDay;
          this.timezone = data.WantTime;
          this.wantRange = data.WantRange;
          this.delivCompany = data.DelivCompany;
          this.timeSet = data.TimeSet;
          console.log(data)
          console.log(data.TimeSet)
          console.log(this.timeSet)
          // 年月日を設定かつ、日間でのプルダウンを生成する
          this.changeYear(year);
          this.changeMonth(month);
          this.changeDay(day);

          if (!this.timezone) {
            this.timezone = this.timezones[0].TimeCode;
          }
        });
    },
    next() {
      // timezoneNameを取得
      const selectTimezone = this.timezones.find(el => el.TimeCode == this.timezone);

      let postParams = [this.year, this.month, this.day, this.timezone, selectTimezone.TimeZone];
      let requestParams = request.createParams(
        "webMdlShippingAddress",
        "putDeliveryDate",
        postParams
      );
      request
        .create()
        .post("", requestParams)
        .then(() => {
          this.$router.push("/cart/payment");
        });
    },
  },
};
</script>

